<ng-container *transloco="let t">
  @if (entityChange()) {
    <app-dashboard-pill-entity-selector
      [value]="dataSource() ?? comparison() ?? widgetGroup()"
      [dataSources]="datasourceManagerStore.getDatasources()"
      [dataSourceType]="dataSourceType()"
      [entityList]="entityList()"
      [mode]="pillType()"
      [widget]="widget()"
      [report]="report()"
      [dashboard]="dashboard()"
      [widgetComponent]="widgetComponent()"
      (cancel)="showOrHideEntityChange(false)"
      (entitySelected)="onEntitySelect($event)"
    ></app-dashboard-pill-entity-selector>
  } @else {
    @if (shouldShowMenu()) {
      <div [matMenuTriggerFor]="dropdownMenuTemplate()">
        <ng-container *ngTemplateOutlet="pillButton"></ng-container>
      </div>
    } @else {
      <div (click)="onPillClick()">
        <ng-container *ngTemplateOutlet="pillButton"></ng-container>
      </div>
    }
  }

  <ng-template #pillButton>
    <button
      mat-flat-button
      [matTooltip]="tooltip()"
      matTooltipClass="dashboard-pill-tooltip"
      [disabled]="disabled() || (isReadOnly() && pillType() !== ActivityBarPillTypeEnum.COMPARISON)"
      [class.dashboard-pill--hovered]="isHovered()"
      [class.dashboard-pill--condensed]="isCondensed()"
      [class.dashboard-pill--first]="first()"
      [class.dashboard-pill--last]="last()"
      class="dashboard-pill"
      [style.background-color]="color()"
      [style.color]="textColor()"
    >
      <mat-icon fontSet="kitchen-icons" [fontIcon]="icon()" [style.color]="textColor()"></mat-icon>

      @if (!isCondensed()) {
        {{ title() | truncate: 24 }}
      }
    </button>
  </ng-template>

  <mat-menu class="menu-with-xi-icons" #widgetGroupMenu>
    @if (!widget()) {
      <button mat-menu-item (click)="onMemberEdit()">
        {{ t('dashboard-pill.widget-group-edit-members') }}
      </button>
    } @else {
      <button mat-menu-item (click)="showOrHideEntityChange(true)">
        {{ t('dashboard-pill.widget-group-change') }}
      </button>

      @if (widget()?.id === widgetGroup()?.parentWidget) {
        <button mat-menu-item (click)="onDemote()">
          {{ t('dashboard-pill.widget-group-demote') }}
        </button>
      }

      <button mat-menu-item (click)="onWidgetGroupRemove()">
        {{ t('dashboard-pill.widget-group-remove') }}
      </button>
    }
  </mat-menu>

  <mat-menu class="menu-with-xi-icons" #dashboardGroupMenu>
    <button mat-menu-item (click)="showOrHideEntityChange(true)">
      {{ t('dashboard-pill.change-data-source') }}
    </button>
  </mat-menu>

  <mat-menu class="menu-with-xi-icons" #comparisonGroupMenu>
    @if (!widget()) {
      <button mat-menu-item (click)="onEditComparison()" [disabled]="isReadOnly()">
        {{ t('dashboard-pill.edit-comparison') }}
      </button>

      <ng-container *ngTemplateOutlet="comparisonChangeTemplate"></ng-container>

      <button mat-menu-item (click)="onAddComparisonMembers()" [disabled]="isReadOnly()">
        {{ t('dashboard-pill.comparison-edit-members') }}
      </button>
    } @else {
      <ng-container *ngTemplateOutlet="comparisonChangeTemplate"></ng-container>

      <button mat-menu-item (click)="onRemoveComparison()" [disabled]="isReadOnly()">
        {{ t('dashboard-pill.remove-comparison') }}
      </button>
    }

    <ng-template #comparisonChangeTemplate>
      <button
        mat-menu-item
        (click)="showOrHideEntityChange(true)"
        [disabled]="entityChangeDisabled()"
      >
        {{ t('dashboard-pill.change-comparison') }}
      </button>
    </ng-template>
  </mat-menu>
</ng-container>
